
namespace TabAurous.Scheme {

    @Serenity.Decorators.registerClass()
    export class SchemePaymentGrid extends Serenity.EntityGrid<SchemePaymentRow, any> {
        protected getColumnsKey() { return 'Scheme.SchemePayment'; }
        protected getDialogType() { return SchemePaymentDialog; }
        protected getIdProperty() { return SchemePaymentRow.idProperty; }
        protected getInsertPermission() { return SchemePaymentRow.insertPermission; }
        protected getLocalTextPrefix() { return SchemePaymentRow.localTextPrefix; }
        protected getService() { return SchemePaymentService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }
        protected addButtonClick() {

            let now = new Date();

            var voucherNo = FormatHelper.GetVoucherNo(58);

            this.editItem(<SchemePaymentRow>{
                VoucherNo: voucherNo,
                VoucherTypeId: 58

            });
        }
    }
}